<div class="container greyTextContainer">

  <h1>About</h1>

  <div class="block">

    <p>
      ADIEM is all about putting the participant first. We genuinely care and will always do everything we
      can to assist. We will always respond to queries promptly and do our best to provide peace of mind when
      there are concerns. We are always available to answer questions.
    </p>

    <p>
      We will ensure you are aware of your funding balances. ADIEM provides a web portal where you can check your
      budgets and processed invoices at any time. You will also receive a statement each month informing you of how you
      are progressing.
    </p>

    <p>
      ADIEM is managed by Fudge Raco. His story is below...
    </p>

    <br />

    <h2>Why I became an NDIS Plan Manager</h2>

    <div class="outback"></div>



    <p>
      My brother Andrew is three years younger than me and suffers from
      cerebral palsy. We are quite close and when our father passed away a few
      years ago, I took on managing his personal affairs. It was around this
      time that the NDIS had just started and everybody seemed a little unsure
      of how things worked.
    </p>

    <p>
      My interest in plan management came about when my brother Andrew needed
      custom-made boots to go over his new orthotics. These boots were an
      expensive necessity and unfortunately the boot maker wasn't registered
      with the NDIS. This meant that we were going to have to pay the boot
      maker out of our own funds or find another bootmaker who was registered
      as an NDIS provider. Due to the complexity of becoming an approved NIDS
      provider, not many bootmakers out there were qualified.
    </p>

    <p>
      The difficulty that we encountered with using a non-NDIS-registered
      provider made me wonder how difficult this must be for others. I have
      experience in managing businesses and I'm used to dealing with
      government bureaucracy. But what about the exhausted parents out there
      who don't have the time to explore or learn about the NDIS? It can be
      hard to understand and overwhelming at times. So, it was at this moment
      that I decided to become a registered NDIS plan manager. This way, I
      could help others choose the providers they wanted to use without
      needing to worry about whether they were NDIS registered or not.
    </p>


    <p>
      I am in a unique position where I can relate to both providers who run
      businesses and need to be paid promptly, and participants who have enough
      difficulties in life and would prefer one less thing to worry about. My
      purpose is to make everyone's life easier.
    </p>

    <p>
      If you are interested in being plan-managed by us, please enter your details <a
        routerLink="/service-agreement">here</a> and a service agreement will be sent to you.
    </p>
  </div>
</div>